<div class="card m-6">
    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Clientes</h2>
        <p-button 
            label="Adicionar" 
            icon="pi pi-plus" 
            (onClick)="navigateToCreate()" 
            severity="success" />
    </div>

    <!-- Filtros -->
    <div class="mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg font-semibold">Filtros</h3>
            <p-button 
                label="Limpar Filtros" 
                icon="pi pi-filter-slash" 
                severity="secondary"
                size="small"
                (onClick)="clearFilters()" />
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Campo de Busca -->
            <div>
                <label for="searchInput" class="block text-sm font-medium mb-2">Buscar</label>
                <input 
                    type="text" 
                    pInputText 
                    id="searchInput"
                    [(ngModel)]="searchTerm" 
                    placeholder="Pesquisar clientes..." 
                    class="w-full"
                    (input)="onSearchChange(searchTerm)" />
            </div>

            <!-- Filtro por Status Ativo -->
            <div>
                <label for="activeFilter" class="block text-sm font-medium mb-2">Status</label>
                <p-select 
                    id="activeFilter"
                    [(ngModel)]="active"
                    [options]="[
                        { label: 'Ativo', value: true },
                        { label: 'Inativo', value: false }
                    ]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o status"
                    [showClear]="true"
                    (onChange)="onActiveChange($event.value)"
                    class="w-full" />
            </div>

            <!-- Filtro por Pode Solicitar Corrida -->
            <div>
                <label for="canRequestRideFilter" class="block text-sm font-medium mb-2">Pode Solicitar Corrida</label>
                <p-select 
                    id="canRequestRideFilter"
                    [(ngModel)]="canRequestRide"
                    [options]="[
                        { label: 'Sim', value: true },
                        { label: 'Não', value: false }
                    ]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione a opção"
                    [showClear]="true"
                    (onChange)="onCanRequestRideChange($event.value)"
                    class="w-full" />
            </div>
        </div>
    </div>

    <p-table 
        [value]="Customers" 
        [paginator]="true" 
        [rows]="10" 
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
        [tableStyle]="{'min-width': '50rem'}"
        styleClass="p-datatable-striped">
        
        <ng-template #header>
            <tr>
                <th style="width:8%">ID</th>
                <th style="width:20%">Nome</th>
                <th style="width:25%">Email</th>
                <th style="width:15%">Telefone</th>
                <th style="width:15%">Pode solicitar corrida</th>
                <th style="width:10%">Ativo</th>
                <th style="width:20%">Ações</th>
            </tr>
        </ng-template>
        
        <ng-template #body let-customer>
            <tr>
                <td>{{ customer.id }}</td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.email }}</td>
                <td>{{ customer.phone }}</td>
                <td>
                    <p-tag 
                        [value]="customer.canRequestRide ? 'Sim' : 'Não'" 
                        [severity]="customer.canRequestRide ? 'success' : 'danger'" />
                </td>
                <td>
                    <p-tag 
                        [value]="customer.active ? 'Sim' : 'Não'" 
                        [severity]="customer.active ? 'success' : 'danger'" />
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button 
                            icon="pi pi-pencil" 
                            severity="info" 
                            size="small"
                            (onClick)="editCustomer(customer.id)"
                            pTooltip="Editar" />
                    </div>
                </td>
            </tr>
        </ng-template>
        
        <ng-template #empty>
            <tr>
                <td colspan="6" class="text-center py-4">
                    Nenhum cliente encontrado.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
